import React, { useEffect, useMemo } from 'react';
import { Layout, Typography } from 'antd';
import { Header } from 'antd/lib/layout/layout';
import MainMenu from '../../components/menu/Menu';
import ServerStatsContainer from '../../components/cards/cardServerStats/ServerStatsContainer';
import EventsTable from '../../components/tables/tableEvents/EventsTable';
import DonutChart from '../../components/charts/donutCharts/DonutChart';
import BarChart from '../../components/charts/barCharts/BarChart';
import AlertModal from '../../components/modals/alertModal/AlertModal';
import { File } from '../../types/File';
import { useServerStatsStore } from '../../store/serverStats/serverStatsStore';
import { formatBytes } from '../../utils/formatBytes';
import { useServerStatsInterval } from '../../hooks/useServerStatsInterval';

const { Content } = Layout;
const { Title, Text } = Typography;

interface MainViewProps {
    currentMenuItem: string;
    handleMenuClick: (key: string) => void;
    onlineDevices: number;
    offlineDevices: number;
    allDevicesLength: number;
    deviceTypeData: { type: string; value: number }[];
    loadingEvents: boolean;
    allEvents: File[];
    alertOpen: boolean;
    setAlertOpen: (open: boolean) => void;
}

const MainView: React.FC<MainViewProps> = ({
    currentMenuItem,
    handleMenuClick,
    onlineDevices,
    offlineDevices,
    allDevicesLength,
    deviceTypeData,
    loadingEvents,
    allEvents,
    alertOpen,
    setAlertOpen,
}) => {
    const currentNetworkTraffic = useServerStatsStore(s => s.currentNetworkTraffic);
    const fetchCurrentNetworkTraffic = useServerStatsStore(s => s.fetchCurrentNetworkTraffic);

    const donutChartColors = useMemo(() => ['#5EC2B7', '#F7B94A', '#F25C5C'], []);

    useServerStatsInterval({
        fetchFunction: fetchCurrentNetworkTraffic,
        interval: 10000,
        enabled: currentMenuItem === 'main',
        maxRetries: 3,
        retryDelay: 1000
    });

    const downloadTraffic = currentNetworkTraffic?.download || 0;
    const uploadTraffic = currentNetworkTraffic?.upload || 0;

    return (
        <Layout style={{ minHeight: '100vh', backgroundColor: '#FFFFFF', height: '100vh', overflowY: 'auto' }}>
            <Header
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: 0,
                    paddingRight: 0,
                }}
            >
                <div className="menu">
                    <MainMenu onClick={handleMenuClick} currentMenuItem={currentMenuItem} />
                </div>
            </Header>
            <Content style={{ padding: '24px', height: 'calc(100vh - 64px)', overflowY: 'auto' }}>
                <div className="main-stats-row">
                    <div className="main-stats-block compact">
                        <div className="main-stats-item">
                            <Text className="main-stats-label">Онлайн устройства</Text>
                            <Title level={4} className="main-stats-value">{onlineDevices}</Title>
                        </div>
                        <div className="main-stats-item">
                            <Text className="main-stats-label">Оффлайн устройства</Text>
                            <Title level={4} className="main-stats-value">{offlineDevices}</Title>
                        </div>
                        <div className="main-stats-item">
                            <Text className="main-stats-label">Все устройства</Text>
                            <Title level={4} className="main-stats-value">{allDevicesLength}</Title>
                        </div>
                    </div>
                    <div className="main-stats-block traffic-block">
                        <div className="main-stats-item">
                            <Text className="main-stats-label">Трафик сервера загрузка</Text>
                            <Title level={4} className="main-stats-value">{formatBytes(downloadTraffic)}</Title>
                        </div>
                        <div className="main-stats-item">
                            <Text className="main-stats-label">Трафик сервера отдача</Text>
                            <Title level={4} className="main-stats-value">{formatBytes(uploadTraffic)}</Title>
                        </div>
                    </div>
                </div>
                <div className="charts-and-stats-row">
                    <div className="donut-charts-row">
                        <div className="charts-item">
                            <BarChart />
                        </div>
                        <div className="charts-item">
                            <DonutChart
                                title="Распределение устройств"
                                data={deviceTypeData}
                                colors={donutChartColors}
                            />
                        </div>
                    </div>
                    <ServerStatsContainer isPageActive={currentMenuItem === 'main'} />
                </div>
                {/* <div className="events-table-container">
                    <EventsTable
                        events={allEvents.slice(0, 10)}
                        loading={loadingEvents}
                        onTitleClick={() => setAlertOpen(true)}
                    />
                </div> */}
                <AlertModal
                    open={alertOpen}
                    onOk={() => setAlertOpen(false)}
                    onCancel={() => setAlertOpen(false)}
                />
            </Content>
        </Layout>
    );
};

export default MainView; 